var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{visible: _vm.isIOS && !_vm.showMobileFooter && !_vm.$kiosk && !_vm.hasBranding && !_vm.$pos},attrs:{"id":"history-back"},on:{"click":_vm.historyBack}},[_c('svgicon',{attrs:{"src":"icons/back.svg","height":24,"width":24}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }